export default __webpack_public_path__ + "static/media/discussion3page1.b78ed2c8.jpg";